module.exports = __webpack_public_path__ + "docker-daemon.svg";